// Aturan tombol Owner pada pesanan Offline: Selesai Darurat vs Ambil.
const POLOSAN = new Set(["Polosan Siap Stok", "Polosan Perlu Jahit"]);
const FINAL_STATUSES = new Set(["Selesai", "Diambil", "Dikirim", "Dibatalkan"]);

export const isOfflineProductionDone = (o) => {
  const ps = Array.isArray(o?.products) ? o.products : [];
  return ps.length > 0 && ps.every(p => p && (p.production_stage === "Selesai" || POLOSAN.has(p.production_route)));
};

export const isOfflinePicked = (o) => o?.pickup_status === "Diambil" || o?.order_status === "Diambil" || o?.order_status === "Dikirim";

export const canShowCompleteOverride = (o, isOwner) => !!isOwner
  && !FINAL_STATUSES.has(o?.order_status)
  && !isOfflinePicked(o)
  && !isOfflineProductionDone(o)
  && (o?.order_status !== "Draft" || !!o?.is_migrated);

export const canShowOwnerAmbil = (o, isOwner) => !!isOwner
  && o?.payment_status === "Lunas"
  && o?.order_status !== "Dibatalkan"
  && !isOfflinePicked(o)
  && (isOfflineProductionDone(o) || o?.order_status === "Selesai");
